import { css } from "@emotion/css";
import { space, text } from "@octopusdeploy/design-system-tokens";
interface ListDescriptionProps {
    description: string | React.ReactElement | React.ReactElement[];
}
/**
 * ListDescription displays a description for a list item.
 * Strings render as a `<p>`, ReactElements render in a `<div>`.
 * If the description is an empty string, the component will return null.
 *
 * @example
 * <ListDescription description="Simple text description" />
 * <ListDescription description={<CustomComponent />} />
 */
export function ListDescription({ description }: ListDescriptionProps) {
    if (description === "" || (Array.isArray(description) && description.length === 0)) {
        return null;
    }
    if (typeof description === "string") {
        return <p className={listDescriptionStyles}>{description}</p>;
    }
    return <div className={listDescriptionContainerStyles}>{description}</div>;
}
//TODO: Remove marginBottom and add text-box-trim to heading when supported (added to visually align due to extra space in font for the title)
const baseStyles = {
    margin: 0,
    font: text.body.regular.medium,
    marginBottom: space[2],
} as const;
const listDescriptionStyles = css(baseStyles);
const listDescriptionContainerStyles = css({
    ...baseStyles,
    display: "flex",
    flexDirection: "column",
    gap: space[8],
});
